import(/* webpackMode: "eager" */ "/app/src/app/search/result/error.tsx");
